// src/data/infoPages.js
// Pages d'information publiques : /tarifs et /cyberguard-et-monaidecyber.
// Fichier sans import : il est aussi lu par scripts/prerender.mjs pour générer le HTML statique.
// Les prix viennent de src/data/landingContent.js (TRANSLATIONS.fr.plans) pour rester à jour en un seul endroit.
// Chaque ligne du comparatif correspond à une fonctionnalité réellement disponible dans l'application.

const infoPages = [
  {
    slug: 'tarifs',
    navLabel: 'Tarifs',
    seoTitle: 'Tarifs CyberGuard : test de sécurité dès 29 €/mois',
    description:
      "Les offres CyberGuard pour PME et agences : 1 audit offert, puis dès 29 €/mois sans engagement. Comparatif des plans Starter, Pro et Enterprise.",
    kicker: 'Tarifs',
    h1: 'Des tarifs simples, sans engagement',
    intro: [
      "Votre premier audit est offert à l'inscription, sans carte bancaire. Vous voyez votre note de A à G et la liste des points à corriger avant de décider quoi que ce soit.",
      "Ensuite, chaque plan est un abonnement mensuel, résiliable à tout moment depuis votre espace : l'accès reste ouvert jusqu'à la fin du mois déjà payé.",
    ],
    showPlans: true,
    comparisonTitle: 'Ce que contient chaque plan',
    comparison: [
      { label: 'Audits par mois', values: ['5', '30', 'Illimités'] },
      { label: 'Certificat SSL, redirection HTTPS, HSTS, CSP, X-Frame-Options', values: [true, true, true] },
      { label: 'Emails : SPF, DKIM, DMARC, serveurs MX', values: [true, true, true] },
      { label: 'Mentions légales, confidentialité, bandeau cookies', values: [true, true, true] },
      { label: 'Note de A à G et score sur 100', values: [true, true, true] },
      { label: 'En-têtes avancés, CORS, cookies, version du serveur', values: [false, true, true] },
      { label: 'Rapport IA en langage simple et guide de correction par point', values: [false, true, true] },
      { label: 'Analyse approfondie (fichiers sensibles, chiffrement, CMS, sous-domaines) sur domaine vérifié', values: [false, true, true] },
      { label: 'Surveillance hebdomadaire avec alerte email si le score baisse', values: [false, '10 domaines', '50 domaines'] },
      { label: "Alerte email avant l'expiration du certificat SSL", values: [false, true, true] },
      { label: 'Marque blanche : rapports PDF et liens de partage à votre logo', values: [false, false, true] },
      { label: 'Fiches clients illimitées', values: [false, false, true] },
      { label: 'Accès API REST', values: [false, false, true] },
    ],
    sections: [
      {
        title: 'Quel plan choisir ?',
        paragraphs: [
          "Starter convient pour vérifier régulièrement votre propre site et vos emails : c'est la base que tout site professionnel devrait respecter.",
          "Pro est fait pour les entreprises qui veulent corriger sans être expertes : chaque point est expliqué en langage simple, avec la consigne exacte à transmettre à votre prestataire, et votre site est surveillé chaque semaine.",
          "Enterprise s'adresse aux agences web et aux prestataires informatiques qui suivent plusieurs clients : rapports à votre marque, fiches clients et liens de partage sans compte pour vos clients.",
        ],
      },
      {
        title: 'Ce que CyberGuard est, et ce qu’il n’est pas',
        paragraphs: [
          "CyberGuard est un contrôle de sécurité automatisé et non intrusif : il analyse ce qui est visible de l'extérieur (site, certificat, configuration des emails, pages légales) et vous explique comment corriger. Il ne remplace pas un audit mené par un expert ni un test d'intrusion, qui examinent aussi votre organisation et cherchent activement à exploiter les failles.",
        ],
      },
    ],
    faqs: [
      { q: 'Y a-t-il un engagement ?', a: "Non. L'abonnement est mensuel et se résilie à tout moment depuis la page Facturation. La résiliation prend effet à la fin du mois en cours, déjà payé." },
      { q: 'Puis-je changer de plan ?', a: "Oui, à tout moment depuis votre espace. Le changement est immédiat et la différence est calculée au prorata sur votre prochaine facture." },
      { q: "L'audit offert est-il vraiment gratuit ?", a: "Oui : un audit complet par compte, sans carte bancaire, une fois votre adresse email confirmée. Le rapport IA et le guide de correction sont réservés aux plans Pro et Enterprise." },
      { q: 'Comment payer et obtenir mes factures ?', a: "Le paiement se fait par carte bancaire via Stripe ; CyberGuard n'a jamais accès à votre numéro de carte. Vos factures sont téléchargeables à tout moment depuis la page Facturation." },
      { q: 'Les scans de surveillance comptent-ils dans mon quota ?', a: "Non. Les scans hebdomadaires automatiques des plans Pro et Enterprise ne sont pas décomptés de vos audits du mois." },
    ],
    ctaTitle: 'Commencez par votre audit offert',
    cta: 'Créer mon compte gratuitement',
    related: [
      { href: '/cyberguard-et-monaidecyber', label: 'Vous avez fait le diagnostic MonAideCyber ? Voici la suite' },
      { href: '/blog/pentest-vs-scan-vulnerabilites', label: 'Test d’intrusion ou scan de vulnérabilités : que choisir ?' },
    ],
  },
  {
    slug: 'cyberguard-et-monaidecyber',
    navLabel: 'Après MonAideCyber',
    seoTitle: 'MonAideCyber et CyberGuard : la suite du diagnostic',
    description:
      "MonAideCyber évalue l'organisation de votre cybersécurité ; CyberGuard contrôle et surveille ce qui est visible de votre site et de vos emails. Deux démarches complémentaires.",
    kicker: 'Complémentarité',
    h1: 'Vous avez fait le diagnostic MonAideCyber ? Voici la suite',
    intro: [
      "MonAideCyber est un service gratuit de l'ANSSI : un Aidant cyber, bénévole formé par l'agence, réalise avec vous un diagnostic de premier niveau de la cybersécurité de votre organisation.",
      "CyberGuard ne le remplace pas. Il s'occupe d'une autre partie du sujet : ce qui est visible de l'extérieur, votre site web et vos emails, et il le surveille dans la durée.",
    ],
    sections: [
      {
        title: 'Ce que fait MonAideCyber',
        paragraphs: [
          "Le diagnostic dure environ une heure à une heure et demie. Il prend la forme d'un échange guidé par un questionnaire, sur des thèmes comme la gouvernance, la gestion des accès, la sécurité des postes et des infrastructures, la sensibilisation des équipes et la réaction en cas d'attaque.",
          "Vous repartez avec six mesures prioritaires à mettre en œuvre dans les six mois, par exemple activer la double authentification ou mettre en place des sauvegardes. Le service s'adresse aux TPE-PME, aux associations et aux collectivités, et se demande en ligne sur monaide.cyber.gouv.fr.",
        ],
      },
      {
        title: 'Ce que fait CyberGuard',
        paragraphs: [
          "CyberGuard analyse automatiquement, en deux minutes, ce que n'importe qui peut voir de votre organisation depuis internet : la validité de votre certificat SSL, les protections de votre site (en-têtes de sécurité), la configuration de vos emails contre l'usurpation (SPF, DKIM, DMARC) et la présence de vos mentions légales.",
          "Chaque point est noté et expliqué en langage simple, avec la consigne à transmettre à votre prestataire. Sur les plans Pro et Enterprise, votre site est ensuite revérifié chaque semaine et vous êtes prévenu par email si quelque chose se dégrade ou si votre certificat va expirer.",
        ],
      },
      {
        title: 'Pourquoi les deux se complètent',
        items: [
          { term: 'Organisation et technique', text: "MonAideCyber vous aide à organiser votre sécurité (qui a accès à quoi, sauvegardes, réaction). CyberGuard vérifie des réglages techniques précis de votre site et de vos emails, que le diagnostic n'a pas pour objet de tester." },
          { term: 'Un moment et la durée', text: "Le diagnostic fait le point à un instant donné, avec un suivi à six mois. CyberGuard contrôle en continu : un certificat oublié ou un réglage modifié par une mise à jour sont repérés la semaine où ils apparaissent." },
          { term: 'Des mesures à suivre', text: "Certaines mesures issues du diagnostic se vérifient de l'extérieur, comme la protection de vos emails contre l'usurpation : CyberGuard vous confirme qu'elles sont bien en place, et qu'elles le restent." },
        ],
      },
      {
        title: 'Bon à savoir',
        paragraphs: [
          "CyberGuard est un service privé et indépendant : il n'est ni affilié à l'ANSSI ni partenaire de MonAideCyber. Si vous n'avez pas encore fait le diagnostic, nous vous le recommandons : il est gratuit et c'est un très bon point de départ.",
        ],
      },
    ],
    faqs: [
      { q: 'MonAideCyber est-il payant ?', a: "Non, le diagnostic MonAideCyber est gratuit. Il est proposé par l'ANSSI et réalisé par des Aidants cyber bénévoles." },
      { q: 'CyberGuard remplace-t-il le diagnostic ?', a: "Non. Le diagnostic évalue l'organisation de votre cybersécurité avec un humain ; CyberGuard contrôle automatiquement des réglages techniques visibles depuis internet. Les deux démarches se complètent." },
      { q: 'Par quoi commencer ?', a: "Les deux sont rapides. Votre premier audit CyberGuard est offert et prend deux minutes : vous pouvez le lancer tout de suite, puis demander un diagnostic MonAideCyber pour la partie organisationnelle." },
    ],
    ctaTitle: 'Contrôlez votre site et vos emails en deux minutes',
    cta: 'Lancer mon audit offert',
    sources: [
      { href: 'https://monaide.cyber.gouv.fr', label: 'MonAideCyber (site officiel)' },
      { href: 'https://www.blogdumoderateur.com/outils-gratuits-renforcer-cybersecurite-entreprise/', label: 'Blog du Modérateur, outils gratuits de cybersécurité (1er octobre 2026)' },
      { href: 'https://www.fiducial.fr/Articles-et-dossiers/MonAideCyber-Diagnostic-gratuit-pour-proteger-les-TPE-PME', label: 'Fiducial, MonAideCyber : diagnostic gratuit pour les TPE-PME (mis à jour le 12 mars 2025)' },
    ],
    related: [
      { href: '/verifier-dmarc-spf-dkim', label: 'Vérifier la protection de vos emails (DMARC, SPF, DKIM)' },
      { href: '/tarifs', label: 'Voir les tarifs' },
    ],
  },
];

export default infoPages;
